import { FC, SelectHTMLAttributes } from "react";
import classNames from "classnames";
import { evoSelectClassName } from "./evoFieldStyles";

type Props = SelectHTMLAttributes<HTMLSelectElement> & {
  className?: string;
};

export const EvoSelect: FC<Props> = ({ className, children, ...rest }) => {
  return (
    <select className={classNames(evoSelectClassName, className)} {...rest}>
      {children}
    </select>
  );
};
